import React from 'react';
import { useRef, useState, useEffect } from 'react';
import { getCountData } from '../utils/notionClient';
import '../assets/css/about.css';
import { Link } from 'react-router-dom';
import { ReactComponent as Logo } from '../assets/images/logo.svg';
import { Pagination, Autoplay } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';

import { TitleBar } from '../components/TitleBar'
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/autoplay';
import { TopButton } from "../components/TopButton"

import { gsap } from "gsap";
import { useGSAP } from '@gsap/react';
import { ScrollTrigger } from "gsap/ScrollTrigger"
import { getStoryDatabase } from '../utils/notionClient';

export default function AboutPage() {

  const [countData, setCountData] = useState({
    special_donation: ''
  });
  const [storyData, setStoryData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [open, setOpen] = useState(false);
  const [dialogContent, setDialogContent] = useState({});

  useEffect(() => {
    const fetchCountData = async () => {
      try {
        const data = await getCountData();
        setCountData({
          special_donation: data.special_donation || ''
        });
      } catch (error) {
        console.error('Failed to fetch count data:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchCountData();
  }, []);

  useEffect(() => {
    const fetchStoryData = async () => {
      try {
        const data = await getStoryDatabase();
        setStoryData(data);
      } catch (error) {
        console.error('Failed to fetch story data:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchStoryData();
  }, []);


  useEffect(()=>{
    const titleElement = document.getElementsByTagName('title')[0];
    titleElement.innerHTML = `소개 | 어르신본죽왔어요`;
  },[]);

  const handleClickOpen = (story) => () => {
    setDialogContent(story);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  gsap.registerPlugin(useGSAP, ScrollTrigger);
  const container = useRef();

  useGSAP(() => {
    let tl01 = gsap.timeline({
      default:{duration: 0.1},
    }); // 인트로

    
    tl01.from('.motiona1', { opacity: 0, y: 100, })
        .from('.motiona2', { opacity: 0, y: 100, })
        .from('.motionb1', { opacity: 0, y: 100, })
        .from('.motionb2', { opacity: 0, y: 100, })
        .from('.motionb3', { opacity: 0, y: 100, })
        .from('.motionb4', { opacity: 0, y: 100, })
        .from('.motionc1', { opacity: 0, y: 100, })

  }, { scope: container });

  const STYLES = { 
    videoIframeContainer: { margin: '0 auto', display: 'flex', justifyContent: 'center' }, 
    videoIframe: { margin: '0 auto 80px' } 
  }
  const YOUTUBE = 'https://www.youtube.com/embed/N7bu99xePhU?amp;autoplay=1&amp;mute=1&playlist=N7bu99xePhU&rel=0'
 

    return (
      <article ref={container}>
        <TitleBar />
        <TopButton />

        <section id='summary' className='section inner'>
          <div className='flex flex-wrap'>
            <div className='summary-box1 motiona1'>
              <h4>정성을 담아 전하는 행복 한 그릇,</h4>
              <Logo className='logo-about'/>
              <p>경제적, 환경적 어려움으로 결식이 우려되는 취약계층 어르신들을 위해
              따뜻하고 든든하게 드실 수 있는 죽을 정기적으로 지원하는 
              <br /><b>본죽, 본죽&비빔밥의 대표 사회공헌 활동</b>입니다.</p>
            </div>
            <div className='summary-box2 motiona2'>
            </div>
          </div>
        </section>

        <section>
        <div className='video-youtube' style={STYLES.videoIframeContainer}>
          <iframe
            title="vimeo-player"
            src={YOUTUBE}
            width="800"
            height="450"
            style={STYLES.videoIframe}
          >
          </iframe>
        </div>
        </section>

        <section id='contents' className='inner'>
          <div className='colum flex flex-wrap motionb1'>
            <h4>본죽의 나눔은 대학로 1호점에서부터
            시작되었어요</h4>
            <p>2002년 대학로에 문을 연 본죽 1호점은 밥생명공동체와 함께 노숙인을 위한 식사 나눔으로 사회공헌의 첫걸음을 뗐습니다. 이후 2009년부터 다양한 복지기관과 협력하며 취약계층 지원을 확대해 왔고, 2015년부터는 전국 가맹점과 함께 지역사회의 어르신들을 위한 정기 본죽 나눔을 시작했습니다.</p>
            <div></div>
          </div>
          <div className='colum flex flex-wrap motionb2'>
            <h4>결식우려 취약 어르신을 위해 정기적으로 
            본죽을 나눠요</h4>
            <p>고령화와 노인 빈곤 문제가 심각한 오늘날, 본죽은 결식 우려가 있는 취약 어르신들의 영양 결핍을 해결하기 위해 노력합니다. 한 끼 식사 이상의 의미를 담아, 어르신들이 건강하고 행복한 노후를 보내실 수 있도록 지원합니다.</p>
            <div></div>
          </div>
          <div className='colum flex flex-wrap motionb3'>
            <h4>가맹점, 지역사회와 함께 선한 영향력을 
            펼쳐가요</h4>
            <p>가맹점에서는 매주 어르신을 위한 죽을 정성껏 만듭니다. 복지기관은 죽을 직접 픽업해 어르신께 전하며 안부를 묻고 일상을 살핍니다. 본죽, 본죽&비빔밥 가맹점은 추가 기부로 나눔에 더욱 힘을 보태고 있습니다.</p>
            <div></div>
          </div>
        </section>

        <section id='plus-contents' className='inner motionb4'>
          <p>'어르신 본죽 왔어요'는 특별한 나눔도 진행합니다. 
            <br />동대문 쪽방촌 월간 섬김, 혹서기 보양죽 나눔, 동짓날 동지팥죽 나눔이 연중 이어집니다.</p>
          <span>※ 특별한 나눔 누적 : {loading ? "로딩중..." : countData.special_donation}</span>
        </section>


        <section id='story-module' className='section'>


        <Swiper
        modules={[Pagination, Autoplay]}
        spaceBetween={30}
        slidesPerView={1}
        autoplay
        pagination={true}
        className="article-swiper inner motionc1"
        breakpoints={{
          768: {
            slidesPerView: 2,
            spaceBetween: 40,
          },
          1024: {
            slidesPerView: 3,
            spaceBetween: 50,
          },
        }}
      >
          {loading ? (
            <div className="loading-container">데이터를 불러오는 중...</div>
          ) : storyData && storyData.length > 0 ? (
            [...storyData].reverse().map((story) => (
              <SwiperSlide className="article-slide" key={story.postId}>        
                <button className='story-slide' onClick={handleClickOpen(story)}>
                  <div className='thumb'>
                    {story.img && <img src={story.img} alt={story.title || '이미지'} />}
                  </div>
                  <div className='title'>
                    {story.type && <p>{story.type}</p>}
                    {story.title && <h4>{story.title}</h4>}
                  </div>
                </button>
              </SwiperSlide>
            ))
          ) : (
            <div className="no-data">데이터가 없습니다.</div>
          )}
      </Swiper>

      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className='story-dialog'
        scroll='paper'
        PaperProps={{
          sx: {
            maxHeight: '90vh',
            overflowY: 'auto'
          }
        }}
      >
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={(theme) => ({
            position: 'absolute',
            right: 8,
            top: 8,
            color: theme.palette.grey[500],
            zIndex: 1
          })}
        >
          <CloseIcon />
        </IconButton>

        <div className='story-img'>
          <img src={dialogContent.img} alt={dialogContent.title} />
        </div>
        
        <DialogTitle id="alert-dialog-title">
          {dialogContent.title}
        </DialogTitle>

        <DialogContent sx={{ padding: '20px', overflowY: 'visible' }}>
          <DialogContentText id="alert-dialog-description">
            <p>{dialogContent.description}</p>
            <Link to={dialogContent.link} target="_blank">👉 링크 바로가기</Link>
          </DialogContentText>
        </DialogContent>
      </Dialog>

        </section>

      </article>
    );
  };
  